import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';

import QuestionnaireItem from '../QuestionnaireItem';
import BasePageCard from 'components/wrappers/BasePageCard';
import { AssignmentQuestionnaireInfoModel } from 'api/adminApiClient';
import { AssignmentDetailsModel } from 'utils/assignmentUtils';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { MemberQuestionnaireModal } from 'features/assignment/Questionnaire/QuestionnaireModals';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './MemberQuestionnaireSection.module.less';

type Props = {
  assignmentId?: string;
  assignmentKey?: string;
  questionnaireInfo: AssignmentQuestionnaireInfoModel;
  setPrimaryDetails?: (data: AssignmentDetailsModel) => void;
};

export default function MemberQuestionnaireSection(props: Props) {
  const {
    assignmentId = '',
    assignmentKey = '',
    questionnaireInfo,
    setPrimaryDetails,
  } = props;
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const isAdmin = useAppSelector(isAdminSelector);

  return (
    <>
      {isEditModalVisible && setPrimaryDetails && (
        <MemberQuestionnaireModal
          isAdmin={isAdmin}
          isEditMode
          assignmentId={assignmentId}
          assignmentKey={assignmentKey}
          questionnaireInfo={questionnaireInfo}
          onClose={() => setIsEditModalVisible(false)}
          setPrimaryDetails={setPrimaryDetails}
        />
      )}
      <Col xs={24} className="d-flex">
        <BasePageCard
          className="stretch-card"
          title="Member questionnaire"
          icons={<span className="icon icon-id-card" />}
          subTitle={
            isAdmin && (
              <Button
                onClick={() => setIsEditModalVisible(true)}
                className="with-icon mobile-icon-only"
                size="large"
                icon={<span className="icon icon-edit" />}
              >
                Edit
              </Button>
            )
          }
        >
          <div className="content-wrapper">
            <Row gutter={[20, 20]}>
              <Col xs={24} md={12} className={styles.rightBlock}>
                <Row gutter={[5, 5]}>
                  <Col
                    xs={24}
                    data-id="memberQuestionnaireOngoingTrainingRequired"
                  >
                    <QuestionnaireItem
                      title="Ongoing training required:"
                      questionnaireItem={
                        questionnaireInfo?.ongoingTrainingRequired
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="memberQuestionnaireClockInOrOutDictated"
                  >
                    <QuestionnaireItem
                      title="Clock in or out dictated:"
                      questionnaireItem={
                        questionnaireInfo?.clockInOrOutDictated
                      }
                    />
                  </Col>

                  <Col xs={24} data-id="memberQuestionnaireSuppliesProvision">
                    <QuestionnaireItem
                      title="Supplies provision:"
                      questionnaireItem={questionnaireInfo?.suppliesProvision}
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="memberQuestionnaireSpecializedSkillsetEmployeeAvailbility"
                  >
                    <QuestionnaireItem
                      title="Specialized skillset employee availability:"
                      questionnaireItem={
                        questionnaireInfo?.specializedSkillsetEmployeeAvailbility
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="memberQuestionnaireWorkerPerformedSimilarServices"
                  >
                    <QuestionnaireItem
                      title="Worker performed similar services:"
                      questionnaireItem={
                        questionnaireInfo?.workerPerformedSimilarServices
                      }
                    />
                  </Col>
                </Row>
              </Col>

              <Col xs={24} md={12}>
                <Row gutter={[5, 5]}>
                  <Col xs={24} data-id="memberQuestionnaireCustomerControl">
                    <QuestionnaireItem
                      title="Customer control:"
                      questionnaireItem={questionnaireInfo?.customerControl}
                    />
                  </Col>

                  <Col xs={24} data-id="memberQuestionnaireSupervisionOfWorker">
                    <QuestionnaireItem
                      title="Supervision of worker:"
                      questionnaireItem={questionnaireInfo?.supervisionOfWorker}
                    />
                  </Col>
                  <Col
                    xs={24}
                    data-id="memberQuestionnaireBusinessExpensesReimbursed"
                  >
                    <QuestionnaireItem
                      title="Business expenses reimbursed:"
                      questionnaireItem={
                        questionnaireInfo?.businessExpensesReimbursed
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="memberQuestionnaireServicesAreKeyAspectOfBM"
                  >
                    <QuestionnaireItem
                      title="Services are key aspect of BM:"
                      questionnaireItem={
                        questionnaireInfo?.servicesAreKeyAspectOfBM
                      }
                    />
                  </Col>

                  <Col
                    xs={24}
                    data-id="memberQuestionnaireServicesAdvertisedByWorker"
                  >
                    <QuestionnaireItem
                      title="Services advertised by worker:"
                      questionnaireItem={
                        questionnaireInfo?.servicesAdvertisedByWorker
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </BasePageCard>
      </Col>
    </>
  );
}
